//ElevenLabs voice - premium
//Google, Azure Voices, Speechify - basic
//Cartesia - pro

const newVoices = {
  Eva: { label: "Eva (multilingual)" },
  Andy: { label: "Andy (multilingual)" },
  Ian: { label: "Ian (English-AU)" },
  Carly: { label: "Carly (English-US)" },
  Sophia: { label: "Sophia (English-US)" },
  Ignacio: { label: "Ignacio (English-US)" },
  // Cindy: { label: "Cindy (English-US)" },
  // Arthor: { label: "Arthor (English-US)" },
  Kavya: { label: "Kavya (Hindi)" },
  Shantanu: { label: "Shantanu (Hindi)" },
  Lucia: { label: "Lucia (Spanish)" },
  Fernanda: { label: "Fernanda (Spanish)" },
  Asif: { label: "Asif (Urdu)" },
  Sabbah: { label: "Sabbah (Arabic-UAE)" },
  Aisha: { label: "Aisha (Arabic)" },
  Ismail: { label: "Ismail (Arabic)" },
  Agata: { label: "Agata (Polish)" },
  Piyali: { label: "Piyali (Bengali)" },
  Eliana: { label: "Eliana (Hebrew)" },
  Moshe: { label: "Moshe (Hebrew)" },
  Inbar: { label: "Inbar (Hebrew)" },
  Saad: { label: "Saad (Indian English)" },
  Nisha: { label: "Nisha (Indian English)" },
  Shilpa: { label: "Shilpa (Indian English)" },
  Divya: { label: "Divya (Hinglish)" },
  Dhruv: { label: "Dhruv (Hindi)" },
};

enum VoiceProvider {
  Elevenlabs = "elevenlabs",
  Cartesia = "cartesia",
  Rimeai = "rimeai",
  SuperdashTTS1 = "superdashtts1",
  SuperdashTTS2 = "superdashtts2",
}

const basicVoices = {
  Eva: { label: "Eva (multilingual)" },
  Andy: { label: "Andy (multilingual)" },
  Kavya: { label: "Kavya (Hindi)" },
  Shantanu: { label: "Shantanu (Hindi)" },
  Lucia: { label: "Lucia (Spanish)" },
  Asif: { label: "Asif (Urdu)" },
  Agata: { label: "Agata (Polish)" },
  Piyali: { label: "Piyali (Bengali)" },
  Eliana: { label: "Eliana (Hebrew)" },
};

const basicPlusVoices = {
  Carly: { label: "Carly (English-US)" },
  Nita: { label: "Nita (Hinglish)" },
  Simar: { label: "Simar (Hinglish)" },
  Saif: { label: "Saif (Hinglish)" },
  Aisha: { label: "Aisha (Arabic)" },
  Ismail: { label: "Ismail (Arabic)" },
  Moshe: { label: "Moshe (Hebrew)" },
  Inbar: { label: "Inbar (Hebrew)" },
};

const proVoices = {
  Sophia: { label: "Sophia (English-US)" },
  Ignacio: { label: "Ignacio (English-US)" },
  Saad: { label: "Saad (Indian English)" },
  Nisha: { label: "Nisha (Indian English)" },
  Shilpa: { label: "Shilpa (Indian English)" },
  Divya: { label: "Divya (Hinglish)" },
  Dhruv: { label: "Dhruv (Hindi)" },
};

const superdashVoices = {
  Nisha_SD: { label: "Nisha (Hinglish)" },
  Pamuli: { label: "Pamuli (Hinglish)" },
  Purnima: { label: "Purnima (Hinglish)" },
  // Saad_SD: { label: "Saad (Hinglish)" },
  Prashaant: { label: "Prashaant (Hinglish)" },
  Nia: { label: "Nia (Hinglish)" },
  Avanthika_ML: { label: "Avanthika (Malayalam)" },
  Sunil_ML: { label: "Sunil (Malayalam)" },
  Malli_TE: { label: "Malli (Telugu)" },
  Nikitha_MR: { label: "Nikitha (Marathi)" },
  Apsara_BN: { label: "Apsara (Bengali)" },
  Snigdha_ORY: { label: "Snigdha (Odia)" },
  Chandra_ORY: { label: "Chandra (Odia)" },
  Siya_KN: { label: "Siya (Kannada)" },
  Krithi_KN: { label: "Krithi (Kannada)" },
  Kavitha_TA: { label: "Kavitha (Tamil)" },
};

const premiumVoices = {
  Ian: { label: "Ian (English-AU)" },
  Sabbah: { label: "Sabbah (Arabic-UAE)" },
  Fernanda: { label: "Fernanda (Spanish)" },
};

export {
  basicVoices,
  basicPlusVoices,
  superdashVoices,
  proVoices,
  premiumVoices,
  VoiceProvider,
};
